import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'Modal';
import { Button } from 'Button';
import { Text } from 'Text';
import { useNavigationHelper } from 'FrontRoyalAngular';
import '../locales/streamDashboard/streamDashboard-en.json';

/*
    Shown when a visitor taps a lesson. LEARN MORE leaves the app, so it calls goToMarketingHome, not the router.
*/

type Props = {
    brandName: string;
    onClose: () => void;
};

export const NoUserUpsellModal: FC<Props> = ({ brandName, onClose }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });
    const { loadRoute, goToMarketingHome } = useNavigationHelper();

    return (
        <Modal title={t('join', { brandName })} onClose={onClose} size="md">
            <div className="flex flex-col gap-6 px-7.5 pb-10 pt-6">
                <Text as="p" className="text-center text-md text-black">
                    {t('join_for_upsell_desc', { brandName })}
                </Text>

                <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-center">
                    <Button
                        variant="bordered"
                        color="slate-grey"
                        onPress={() => {
                            onClose();
                            loadRoute('/sign-in');
                        }}
                    >
                        {t('login')}
                    </Button>
                    <Button
                        color="green"
                        onPress={() => {
                            onClose();
                            goToMarketingHome();
                        }}
                    >
                        {t('learn_more')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
